import React                 from 'react';
import PropTypes             from 'prop-types';
import Modal                 from '@material-ui/core/Modal';
import Warning                from '@material-ui/icons/Warning';
import { Typography }        from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button                from '~/components/Button';
import Paper                 from '~/components/Paper';
import useStyles             from './styles';

/* eslint-disable no-unused-vars */
function ModalAlert(props){
  /* eslint-enable no-unused-vars */
  const { modal, onClose, isLoading, handle, iconColor='error', buttonColor='error', icon=Warning } = props;
  const classes = useStyles();
  return(
    <Modal
      open={modal}
      onClose={onClose}
    >
      <div className={classes.root} >
        <Paper
          classes={{
            root: classes.paper
          }}
          Icon={icon}
          iconColor={iconColor}
          title={'Atenção'}
        >
          <Typography align='center' variant='subtitle1' >
            { 'Esta promoção já está ATIVA.' }
          </Typography>
          <Typography align='center' variant='subtitle1' >
            { 'Não é possível editar!' }
          </Typography>
          
          <div className={classes.rootButtons} style={{textAlign: 'center', justifyContent:'center'}}>
              <Button variant="contained" color={buttonColor} onClick={ handle } className={classes.button}>
                { 'VOLTAR' }
              </Button>
              { isLoading && <CircularProgress size={24} className={classes.buttonProgress} /> }
          </div>
        </Paper>
      </div>
    </Modal>
  );
}

ModalAlert.propTypes={
  deleteAction: PropTypes.func.isRequired,
  message: PropTypes.string,
  name: PropTypes.string,
  modal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  id: PropTypes.any,
  textDelete: PropTypes.string
};
export default ModalAlert;
